export default {
  SET_payment(state, payload) {
    state.payment = payload;
  }
};
